<template>
  <section v-if="!parentType" :id class="container">
    <AddressCard :address />
  </section>
  <div v-else>
    <div>TODO</div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphAddressFragment } from '#graphql-operations'

defineProps<ParagraphAddressFragment>()

const { parentType, index, siblings } = defineBlokkli({
  bundle: 'address',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)
</script>

<style lang="postcss"></style>
